// eslint-disable-next-line import/prefer-default-export
export const namespace = 'features.settings.external_forms.index';
